import React from 'react';
import styled from 'styled-components';
import FlatButton from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import Lottie from 'react-lottie';
import errorAnimationData from 'assets/error.json';
import { media } from 'helpers/MediaHelper';
import { getTranslatedString } from 'helpers/i18n';
import { parseErrorCode } from 'helpers/Errors';

const StyledContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  ${media.mobile`
  padding-top: 50px;
`};
`;

const StyledBtnContainer = styled.div`
  text-align: center;
  margin-bottom: 15px;
`;

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: errorAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const PaysafeFailure = ({ handleClose, paymentError, paymentAuthorizeError }) => {
  let errorMessage = parseErrorCode(paymentError);

  return (
    <StyledContainer>
      <div style={{ margin: '20px 20px 0px', textAlign: 'center' }}>
        <Lottie options={defaultOptions} height={150} width={150} />
      </div>
      <DialogTitle id="payment-dialog" style={{ paddingTop: '0px' }}>
        <h3 style={{ textAlign: 'center', margin: 0, color: colors.DARK_GRAY }}>{errorMessage}</h3>
        <h3 style={{ textAlign: 'center', margin: 0, color: colors.DARK_GRAY }}>
          {paymentAuthorizeError?.responseJSON?.errors[0]}
        </h3>
      </DialogTitle>

      <StyledBtnContainer>
        <FlatButton
          variant="contained"
          onClick={handleClose}
          style={{
            color: 'white',
            backgroundColor: AccentColor(),
          }}
        >
          {getTranslatedString('tenantPortal.paysafe.closeFailure')}
        </FlatButton>
      </StyledBtnContainer>
    </StyledContainer>
  );
};

export default PaysafeFailure;
